import React, { useEffect } from "react";

import TrainingPage from "./pages/TrainingPage";
import useLogin from "./hooks/authHooks/useLogin";
import { useSelector } from "react-redux";
import { useOktaAuth } from "@okta/okta-react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import CreditPage from "./pages/CreditPage";
import TrainingNamesPage from "./pages/TrainingNamesPage";
import UserMaintenancePage from "./pages/ManageUserPage";
import ServicerMaintenancePage from "./pages/ManageServicerPage";
import { UserRole } from "./utils/consts";
import api from "./api/api";

const Main = ({ email }) => {
  const { userName } = useSelector((state) => state.user);
  const { userRole } = useSelector((state) => state.user);
  const { mutate: loginUser } = useLogin(["login"]);
  const { authState } = useOktaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authState.isAuthenticated) {
      loginUser({ email });
      //navigate("/training");
    }
  }, []);

  // const handle402 = async () => {
  //   loginUser({ email: userEmail });
  // };

  // //closing okta session when user gets unathenticated error
  // useEffect(() => {
  //   try {
  //     api.interceptors.response.use(
  //       (response) => {
  //         return response;
  //       },
  //       (error) => {
  //         if (error.response && error.response.status === 402) {
  //           handle402();
  //         }
  //         return Promise.reject(error);
  //       }
  //     );
  //   } catch (e) {}
  // }, []);

  return authState.isAuthenticated ? (
    <Routes>
      <Route path="" element={<TrainingPage />} />
      <Route path="credit" element={<CreditPage />} />
      <Route
        path="admin/user-maintenance"
        element={
          userRole === UserRole.ADMIN ? (
            <UserMaintenancePage />
          ) : (
            <Navigate to="/training" />
          )
        }
      />
      <Route
        path="admin/servicer-maintenance"
        element={
          userRole === UserRole.ADMIN ? (
            <ServicerMaintenancePage />
          ) : (
            <Navigate to="/training" />
          )
        }
      />
       <Route
        path="trainingName"
        element={
          userRole === UserRole.APPROVER ? (
            <TrainingNamesPage />
          ) : (
            <Navigate to="/training" />
          )
        }
      />
    </Routes>
  ) : (
    <Navigate to="/training" />
  );
};

export default Main;
